import axios from 'axios';
import { notification } from 'antd';
import { api_url } from '../configs/app-global';
import { store } from '../redux/store';
import { clearUser } from '../redux/slices/auth';
import i18n from '../configs/i18next';
import { toast } from 'react-toastify';

const service = axios.create({
  baseURL: api_url,
  timeout: 16000,
});

// Config
const TOKEN_PAYLOAD_KEY = 'authorization';
const AUTH_TOKEN = 'token';
const AUTH_TOKEN_TYPE = 'Bearer';

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const access_token = localStorage.getItem(AUTH_TOKEN);

    if (access_token) {
      config.headers[TOKEN_PAYLOAD_KEY] = AUTH_TOKEN_TYPE + ' ' + access_token;
    }
    if (config.method === 'get') {
      config.params = { lang: i18n.language, ...config.params };
    }

    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: 'Error',
    });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const status = error.response?.status;
    const responseMessage = error.response?.data?.message;
    let message = responseMessage || error.message || 'Network error';

    if (status === 403 || status === 401) {
      localStorage.removeItem(AUTH_TOKEN);
      store.dispatch(clearUser());
    }

    if (status === 508 || status === 500) {
      message = responseMessage || message;
    }

    if (error.response?.data?.params) {
      const paramMessage = Object.values(error.response.data.params)[0];
      if (paramMessage) {
        message = Array.isArray(paramMessage) ? paramMessage[0] : paramMessage;
      }
    }

    toast.error(responseMessage ? i18n.t(message) : message, {
      toastId: status || 'network-error',
    });
    return Promise.reject(error);
  }
);

export default service;
